module.exports = __webpack_public_path__ + "27025bd026d6a112b89be5fafea2a0b0.svg";